import { render, staticRenderFns } from "./OrderSubmissionCustomerExtra.vue?vue&type=template&id=641488bc&scoped=true&"
import script from "./OrderSubmissionCustomerExtra.vue?vue&type=script&lang=ts&"
export * from "./OrderSubmissionCustomerExtra.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSubmissionCustomerExtra.vue?vue&type=style&index=0&id=641488bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641488bc",
  null
  
)

export default component.exports